import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import ErrorMessage from '@/components/common/ErrorMessage';
import FormHead from '@/components/common/Form/FormHead';
import FieldLayout from '@/components/Layout/FieldLayout';
import Button from '@/components/ui/Button';
import Label from '@/components/ui/Label';
import PrimaryInput from '@/components/ui/PrimaryInput';
import {
  IAddEmployeeForm,
  IEmployeeOnBoardResponse,
} from '@/interfaces/employee.model';
import { showToastNotification, statesData } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
interface IEmployeeAddressDetailsStep4Props {
  nextStep: () => void;
  empId: string | null;
}
const EmployeeAddressDetailsStep4 = ({
  nextStep,
  empId,
}: IEmployeeAddressDetailsStep4Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    register,
    setValue,
    watch,
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext<IAddEmployeeForm>();
  const handleNextStep = async () => {
    const isValid = await trigger([
      'address',
      'state',
      'city',
      'pinCode',
      'permanentAddress',
      'permanentState',
      'permanentCity',
      'permanentPinCode',
    ]);

    if (isValid && empId) {
      setIsLoading(true);
      const formData = new FormData();
      const data = getValues();
      formData.append('address', data?.address);
      formData.append('state', data?.state);
      formData.append('city', data?.city);
      formData.append('pinCode', data?.pinCode);
      formData.append('permanentAddress', data?.permanentAddress);
      formData.append('permanentState', data?.permanentState);
      formData.append('permanentCity', data?.permanentCity);
      formData.append('permanentPinCode', data?.permanentPinCode);
      formData.append(
        'isSameAsPermanentAddress',
        data?.isSameAsPermanentAddress ? 'true' : 'false',
      );
      try {
        const response: IEmployeeOnBoardResponse = await callApi(
          API_URL + API_ENDPOINT.addEmployee + `?userId=${empId}`,
          { method: 'POST', data: formData, multipart: true },
        );
        if (response?.status) {
          showToastNotification('success', response?.message);
          nextStep();
        }
      } catch (error) {
        if (error && typeof error === 'object' && 'message' in error) {
          showToastNotification('danger', (error as IApiErrorResponse).message);
        } else {
          showToastNotification('danger', 'Something went wrong');
        }
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-6">
          <div className="row">
            <FormHead heading="Present Address" />
            <div className="col-12">
              <div className="form-group mb-3">
                <PrimaryInput
                  required={true}
                  label="Address"
                  id="Address"
                  placeholder="Enter address"
                  errors={errors?.address?.message}
                  defaultValue={''}
                  {...register('address', {
                    ...errorTypes.required('Address'),
                  })}
                />
              </div>
            </div>
            <FieldLayout fieldStyle="col-lg-6">
              <Label id="state" required={true}>
                State
              </Label>
              <select
                className="form-select form-control"
                {...register('state', {
                  ...errorTypes.required('State'),
                })}
              >
                <option value="" className="d-none">
                  Select state
                </option>
                {statesData?.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
              <ErrorMessage message={errors?.state?.message} />
            </FieldLayout>
            <FieldLayout fieldStyle="col-lg-6">
              <PrimaryInput
                required={true}
                label="City"
                id="city"
                placeholder="Enter city"
                errors={errors?.city?.message}
                maxLength={160}
                {...register('city', {
                  ...errorTypes.required('City'),
                })}
                // rows={3}
              />
              {/* <label htmlFor="city" className="form-label">
                  City <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="Pincode"
                  placeholder="Enter City"
                  maxLength={160}
                  {...register('city', {
                    ...errorTypes.required('City'),
                  })}
                />
                <ErrorMessage message={errors?.city?.message} /> */}
            </FieldLayout>
            <FieldLayout fieldStyle="col-lg-6">
              <PrimaryInput
                required={true}
                label="Pin Code"
                id="Pincode"
                type="text"
                placeholder="Enter pin code"
                errors={errors?.pinCode?.message}
                {...register('pinCode', {
                  ...errorTypes.required('Pin code'),
                  ...errorTypes.pinCode,
                })}

                // rows={3}
              />
            </FieldLayout>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="row">
            <div className="col-12">
              <div className="my-3  border-bottom pb-3 d-flex align-items-center justify-content-between">
                <h4 className="fs-3 m-0 rajdhani-semibold">
                  Permanent Address
                </h4>
                <div className="form-check">
                  <input
                    {...register('isSameAsPermanentAddress')}
                    className="form-check-input"
                    type="checkbox"
                    id="presentAdd"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setValue('permanentAddress', watch('address'));
                        setValue('permanentState', watch('state'));
                        setValue('permanentCity', watch('city'));
                        setValue('permanentPinCode', watch('pinCode'));
                      } else {
                        setValue('permanentAddress', '');
                        setValue('permanentState', '');
                        setValue('permanentCity', '');
                        setValue('permanentPinCode', '');
                      }
                    }}
                  />
                  <label className="form-check-label fs-4" htmlFor="presentAdd">
                    Same as present address
                  </label>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-4 mt-2">
                <label htmlFor="Address" className="form-label">
                  Address
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="Address"
                  placeholder="Enter permanent address"
                  defaultValue={''}
                  {...register('permanentAddress', {
                    ...errorTypes.required('Address'),
                  })}
                />
                <ErrorMessage message={errors?.permanentAddress?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  State <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  {...register('permanentState', {
                    ...errorTypes.required('State'),
                  })}
                >
                  <option value="" className="d-none">
                    Select state
                  </option>
                  {statesData?.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
                <ErrorMessage message={errors?.permanentState?.message} />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-group mb-3">
                <label htmlFor="Role" className="form-label">
                  City <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="true"
                  id="Pincode"
                  placeholder="Enter city"
                  maxLength={160}
                  {...register('permanentCity', {
                    ...errorTypes.required('City'),
                  })}
                />
                <ErrorMessage message={errors?.permanentCity?.message} />
              </div>
            </div>
            <FieldLayout fieldStyle="col-lg-6">
              <PrimaryInput
                required={true}
                label="Pin Code"
                id="Pincode"
                type="text"
                className="form-control"
                placeholder="Enter pin code"
                errors={errors?.permanentPinCode?.message}
                {...register('permanentPinCode', {
                  ...errorTypes.required('Pin code'),
                  ...errorTypes.pinCode,
                })}
              />
            </FieldLayout>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <Button
          className="btn btn-primary px-4"
          type="button"
          onClick={handleNextStep}
          isLoading={isLoading}
        >
          Save and Continue
        </Button>
      </div>
    </>
  );
};
export default EmployeeAddressDetailsStep4;
